var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('LoginPage',{attrs:{"login":_vm.login,"loading":_vm.loading},on:{"password-reset":_vm.passwordReset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }